<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="名称"></el-input>
				</el-form-item>
                <!-- <el-form-item>
					<el-input v-model="filters.city" placeholder="城市"></el-input>
				</el-form-item> -->
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow SettingButtonShow btnCon="设置父项目"></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="projects"  highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" border  :height="formHeight" size="mini" :tree-props="{children: 'children'}" row-key="projectId">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
			<el-table-column prop="name" label="名称"  min-width="200" sortable>
			</el-table-column>
			<!-- <el-table-column prop="projectId" label="编号">
			</el-table-column> -->
			<el-table-column prop="city" label="城市" sortable>
			</el-table-column>
            <el-table-column prop="person" label="联系人" sortable>
			</el-table-column>
            <el-table-column prop="telephone" label="联系电话">
			</el-table-column>
			<!-- <el-table-column prop="email" label="邮箱">
			</el-table-column> -->
			<el-table-column prop="buildTime" label="开始时间" min-width="120" >
			</el-table-column>
			<!-- <el-table-column prop="parentProjectName" label="父项目">
			</el-table-column> -->
			<el-table-column prop="remark" label="描述" min-width="200">
			</el-table-column>
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
				</template>
			</el-table-column>
		</el-table>


		<!--From界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formProject" label-width="80px" :rules="formRules" ref="formProject">
				<el-form-item label="名称" prop="name">
					<el-input v-model="formProject.name" ></el-input>
				</el-form-item>
				<el-form-item label="城市"  prop="city">
					<el-input v-model="formProject.city" ></el-input>
				</el-form-item>
                <el-form-item label="联系人">
					<el-input v-model="formProject.person" ></el-input>
				</el-form-item>
                	<el-form-item label="联系电话">
					<el-input v-model="formProject.telephone" ></el-input>
				</el-form-item>
				<el-form-item label="邮箱">
					<el-input v-model="formProject.email"  placeholder="如果多个邮箱，请用;隔开" ></el-input>
				</el-form-item>
				<el-form-item label="开始时间" prop="buildTime">
					<el-date-picker v-model="formProject.buildTime" align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
				</el-form-item>
				<el-form-item label="描述">
                    <el-input v-model="formProject.remark" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<!--Form界面-->
		<el-dialog title="设置项目" :visible.sync="projectVisible" :close-on-click-modal="false">
			<el-form :model="formFatherProject" label-width="80px" ref="formFatherProject">
				<el-form-item label="父项目" prop="project">
					<el-select v-model="formFatherProject.projectId" placeholder="请选择父项目" filterable>
						<el-option label="无" value=0></el-option>
						<el-option
							v-for="item in allProject"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="setFatherProject" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import {getProjects,addProject,updateProject,setFatherProject} from '../../api/api';
	import {formatDate,translateDataToTreeProject} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { myButton,TableUpdateButton},
		data() {
			return {
				filters: {
                    name: '',
                    // city:''
				},
				projects: [],
				allProject:[],
				listLoading: false,
				sels: [],//列表选中列

				formVisible: false,//修改界面是否显示
				projectVisible:false,
				PersonList:[],
                loading: false,
                formRules: {
					name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
					],
					city: [
						{ required: true, message: '请输入城市', trigger: 'blur' }
					],
					 buildTime: [
						{  required: true, message: '请选择时间', trigger: 'change'}
					]
				},
				formHeight:0,
				//界面数据
				formProject: {
					projectId: 0,
					name: '',
					city: '',
					telephone:'',
					person: '',
					remark: '',
					email:'',
					buildTime:new Date()
				},
				formFatherProject:{
					projectId: ''
				},
                type:'新增',
				defaultPropsSingle:{
					children: "children",
          			label: "name",
					value:"projectId"
				}
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getProjects();
				}else if(type=="add"){
					this.handleAdd();
				}else if(type=="setting"){
					this.showProject();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getProjects();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getProjects();
			},
			selsChange: function (sels) {
                this.sels = sels;
			},
			showProject(){
				this.projectVisible=true;
			},
			setFatherProject(){
				var ids = this.sels.map(item => item.projectId);
				this.listLoading = true;
				
				var para=new URLSearchParams();
				para.append('subProjectIds', ids);
				para.append('parentProjectId',this.formFatherProject.projectId);

				setFatherProject(para).then((res) => {
					this.listLoading = false;
					
					let resData = res.data;
					if (resData.code == 200) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
					}else{
						this.$message({
							message: resData.msg,
							type: 'error'
						})
					}
					this.projectVisible=false;
					this.getProjects();
				});
			},
			//查询项目信息
			getProjects() {
				let para = {
                    name: this.filters.name,
                };
				this.listLoading = true;
                getProjects(para).then((res) => {
					this.allProject = res.data.data;
                    this.projects=translateDataToTreeProject(res.data.data);

					this.listLoading = false;
				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.formVisible = true;
				if( this.$refs.formProject!=undefined){
               		this.$refs.formProject.resetFields();
				}
				this.type='修改';
				this.formProject = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
                this.formVisible = true;
                if( this.$refs.formProject!=undefined){
               		this.$refs.formProject.resetFields();
				}
				this.type='新增';
			},
            //Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
            },
			//添加
			addSubmit: function () {
				this.$refs.formProject.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							this.formProject.buildTime =formatDate(this.formProject.buildTime);
							// this.formProject.person=this.formProject.person.toString();
                            let para = Object.assign({}, this.formProject);
                            addProject(para).then((res) => {
								this.loading = false;
                               	let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
                                this.formVisible = false;                                
								this.getProjects();
                            });
						});
					}
				});
            },
            //修改
			editSubmit: function () {
				this.$refs.formProject.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							this.formProject.buildTime =formatDate(this.formProject.buildTime);
							// this.formProject.person=this.formProject.person.toString();
                            let para = Object.assign({}, this.formProject);
                            updateProject(para).then((res) => {
								this.loading = false;
                               	let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
                                this.formVisible = false;                                
								this.getProjects();
                            });
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
            //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
				this.projectVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getProjects();
		}
	}

</script>


// WEBPACK FOOTER //
// Project.vue?2f0640eb